import React from "react";

import useTimer from "../../hooks/useTimer";

const HeaderLayout = ({ routes, menuOpen, onMenuOpen }) => {
  useTimer();
  return <div></div>;
};

HeaderLayout.propTypes = {};

export default HeaderLayout;
